import { render } from "./MultiStatusModal.vue?vue&type=template&id=3871497e&scoped=true&bindings={}"
import script from "./MultiStatusModal.vue?vue&type=script&lang=ts"
export * from "./MultiStatusModal.vue?vue&type=script&lang=ts"

import "./MultiStatusModal.vue?vue&type=style&index=0&id=3871497e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3871497e"

export default script